import { render, staticRenderFns } from "./CustomerAnalysis.vue?vue&type=template&id=16fe90a6&scoped=true&"
import script from "./CustomerAnalysis.vue?vue&type=script&lang=js&"
export * from "./CustomerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAnalysis.vue?vue&type=style&index=0&id=16fe90a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fe90a6",
  null
  
)

export default component.exports